import React from "react";

const LockFilledIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="lock (1) 1">
        <g id="Group">
          <path
            id="Vector"
            d="M18.125 9.371V8.12499C18.125 4.74226 15.3828 2 12 2C8.61722 2 5.875 4.74226 5.875 8.12499V9.371C4.28253 10.066 3.2523 11.6375 3.25 13.375V18.625C3.25287 21.04 5.20993 22.9971 7.62497 23H16.375C18.79 22.9971 20.7471 21.04 20.75 18.625V13.375C20.7477 11.6375 19.7174 10.066 18.125 9.371ZM12.875 16.875C12.875 17.3583 12.4832 17.75 12 17.75C11.5167 17.75 11.125 17.3583 11.125 16.875V15.125C11.125 14.6418 11.5167 14.25 12 14.25C12.4832 14.25 12.875 14.6418 12.875 15.125V16.875ZM16.375 9.00001H7.62497V8.12503C7.62497 5.7088 9.58371 3.75001 12 3.75001C14.4163 3.75001 16.375 5.70876 16.375 8.12503V9.00001Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};

export default LockFilledIcon;
